/**
 * Routes auth publiques (login, mot de passe oublié) — partagé api.js / index.js / Login.
 * REGRESSION (juin 2026) : boucle login PWA — ne pas recharger ni rejouer la file offline ici.
 */

export function normalizeAppPath(pathname = '/') {
  return String(pathname || '/').replace(/\/+$/, '') || '/';
}

export function isOnPublicAuthRoute(pathname) {
  const path = normalizeAppPath(pathname);
  if (path === '/' || path === '/login') return true;
  if (path.startsWith('/forgot-password') || path.startsWith('/reset-password')) return true;
  return false;
}

export function isPublicApiRoute(url = '') {
  return /\/public\//i.test(String(url || ''));
}

export function isAuthApiRoute(url = '') {
  const u = String(url || '');
  return u.includes('/auth/login') || u.includes('/auth/refresh');
}

/**
 * @param {object} opts
 * @param {boolean} opts.hasBearer — access token présent (header ou storage)
 * @param {string} [opts.pathname]
 * @param {string} [opts.url] — URL requête axios
 */
export function shouldScheduleOfflineFlush({
  hasBearer = false,
  pathname = '/',
  url = '',
} = {}) {
  if (!hasBearer) return false;
  if (isOnPublicAuthRoute(pathname)) return false;
  if (isAuthApiRoute(url) || isPublicApiRoute(url)) return false;
  return true;
}
